import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { Paper, CircularProgress, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useAuth } from "../../contexts/auth";
import { getError } from "../../utils/constants";

function LegislativeCommittees() {
  const useStyles = makeStyles((theme) => ({
    paper: {
      padding: theme.spacing(2),
      marginBottom: "30px",
    },
    personList: {
      listStyleType: "none",
    },
    personListItem: {
      marginBottom: "15px",
    }
  }));

  const { token } = useAuth();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(undefined);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/housecommittees`, {
        headers: {
          "Authorization": `JWT ${token()}`,
        },
      });
      if (!res.ok) {
        throw new Error(await res.text());
      }

      const res1 = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/senatecommittees`, {
        headers: {
          "Authorization": `JWT ${token()}`,
        },
      });
      if (!res1.ok) {
        throw new Error(await res1.text());
      }

      const res2 = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/jointcommittees`, {
        headers: {
          "Authorization": `JWT ${token()}`,
        },
      });
      if (!res2.ok) {
        throw new Error(await res2.text());
      }

      setData({ house: await res.json(), senate: await res1.json(), joint: await res2.json() });
    } catch (e) {
      console.error(e);
      setError({type: "error", open: true, message: getError(e)});
    } finally {
      setIsLoading(false);
    }
  }

  if (isLoading) {
    return (
      <CircularProgress />
    );
  }

  if (error) {
    return (
      <Alert severity={error.type}>
        {error.message}
      </Alert>
    );
  }

  return (<>
    <Paper className={classes.paper}>
      <Typography component="h2" noWrap>
        House Committees
      </Typography>
      {data.house.length > 0 && (
        <ul className={classes.personList}>
          {data.house.map((s, i) => (
            <li className={classes.personListItem} key={i}>
              <Link to={`/committee/${s.lID}`}>{s.Name}</Link>
            </li>
          ))}
        </ul>
      )}
    </Paper>
    <Paper className={classes.paper}>
      <Typography component="h2" noWrap>
        Senate Committees
      </Typography>
      {data.senate.length > 0 && (
        <ul className={classes.personList}>
          {data.senate.map((s, i) => (
            <li className={classes.personListItem} key={i}>
              <Link to={`/committee/${s.lID}`}>{s.Name}</Link>
            </li>
          ))}
        </ul>
      )}
    </Paper>
    <Paper className={classes.paper}>
      <Typography component="h2" noWrap>
        Joint Committees
      </Typography>
      {data.joint.length > 0 && (
        <ul className={classes.personList}>
          {data.joint.map((s, i) => (
            <li className={classes.personListItem} key={i}>
              <Link to={`/committee/${s.lID}`}>{s.Name}</Link>
            </li>
          ))}
        </ul>
      )}
    </Paper>
  </>);
}

export default LegislativeCommittees;
